import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';

const redirectedPath = window.location.search;
if (redirectedPath.startsWith("?/")) {
  const cleanPath = redirectedPath.slice(2);
  window.history.replaceState(null, "", "/" + cleanPath);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
